import moment from 'moment-timezone';
import { parseDate } from '../../../utils/dateFormat';

import { getState } from '../../../utils/state';
import { getUrlParams } from '../../../utils/url';

export const CHART_TIME = {
  MIN10: 'MIN10',
  MIN15: 'MIN15',
  HOUR: 'HOUR',
  DAY: 'DAY',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
};

const CHART_TIME_VALUES = {
  MIN10: 10 * 60 * 1000,
  MIN15: 15 * 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
  MONTH: 'MONTH',
  YEAR: 'YEAR',
};

export const getDates = (from, to, step) => {
  const rFrom = new Date(from);
  const rTo = new Date(to);
  const dates = [];
  const rFromTime = rFrom.getTime();
  const rToTime = rTo.getTime();
  const possibleSteps = Object.keys(CHART_TIME_VALUES);
  if (rToTime < rFromTime || !possibleSteps.includes(step)) {
    return [];
  }

  if (step === CHART_TIME_VALUES.MONTH || step === CHART_TIME_VALUES.YEAR) {
    let currentTime = rFromTime;
    while (currentTime < rToTime) {
      const date = new Date(currentTime);
      if (CHART_TIME_VALUES.YEAR === step) {
        const year = date.getFullYear();
        currentTime = date.setFullYear(year + 1);
      } else {
        const month = date.getFullMonth();
        currentTime = date.setMonth(month + 1);
      }
      dates.push(date);
    }
  } else {
    for (let i = rFromTime; i < rToTime; i += CHART_TIME_VALUES[step]) {
      const date = new Date(i);
      dates.push(date);
    }
  }

  return dates;
};

export const zipXY = (x, y) => {
  const result = [];
  for (let i = 0; i < x.length, i < y.length; i++) {
    result.push({ x: x[i], y: y[i] });
  }
  return result;
};

const mapclours = new Map([
  [544, '#74BA05'],
  [545, '#DF4A32'],
  [1293, '#FFCF09'],
  [1941, '#FF8F40'],
]);

const colours = [
  '#006699',
  '#85B200',
  '#FFCF09',
  '#00A2D8',
  '#D90000',
  '#717171',
  '#FD8FFF',
  '#FF7F00',
  '#34B473',
  '#F18F78',
  '#444444',
  '#557A02',
  '#962A11',
  '#6D199E',
  '#AE7DC9',
  '#A2546D',
  '#FFA64D',
  '#DDDDDD',
];

export const getColour = (index = 0) => {
  return colours[index % colours.length];
};

export const doValuesLogic = (setData, isBreakDown, analysis = '') => {
  let tabSelected;
  if (!analysis) {
    tabSelected = getState().analysis.tabSelected.label;
  }

  let addToDate = (value, numToAdd, type) => {
    let dateEnd, dateEndZ;
    dateEnd = moment(new Date(value.x)).add(numToAdd, type);
    dateEndZ = moment(new Date(value.id)).add(numToAdd, type);
    dateEnd = new Date(dateEnd);
    dateEndZ = new Date(dateEndZ);
    return { ...value, x: dateEnd, id: dateEndZ, z: dateEndZ };
  };

  tabSelected = analysis.tabSelected.label;
  let groupBy = analysis.groupby;
  let getLastPoint = (arr) => {
    let value = arr.values.at(-1);
    let groupbyIndicator = arr.tiempo[0]?.id;
    if (groupBy == 'year' || groupbyIndicator == 1) {
      return addToDate(value, 1, 'year');
    } else if (groupBy == 'month' || groupbyIndicator == 2) {
      return addToDate(value, 1, 'month');
    } else if (groupBy == 'day' || groupbyIndicator == 3) {
      return addToDate(value, 1, 'day');
    } else if (groupBy == 'hour' || groupbyIndicator == 4) {
      return addToDate(value, 1, 'hour');
    } else if (groupbyIndicator == 218) {
      return addToDate(value, 15, 'minute');
    } else if (groupbyIndicator == 225) {
      return addToDate(value, 10, 'minute');
    } else if (groupbyIndicator == 219) {
      return addToDate(value, 5, 'minute');
    } else {
      return arr.values.at(-1);
    }
  };
  if (setData.length === 0) {
    return [{ values: [] }];
  }
  setData = setData.map((data, i) => {
    if (mapclours.get(data.excelId) != null) {
      return {
        id: `${data.id}`.replaceAll(' ', '_'),
        areaOpacity: 1,
        type: isBreakDown ? 'area' : 'line',
        dots: true,
        color: mapclours.get(data.excelId),
        ...data,
      };
    } else {
      return {
        id: `${data.id}`.replaceAll(' ', '_'),
        areaOpacity: 1,
        type: isBreakDown ? 'area' : 'line',
        dots: true,
        color: getColour(i),
        ...data,
      };
    }
  });

  if (analysis.indicator.id == 1293 && setData.length == 4) {
    let tempNewData = [...setData];
    setData[0] = tempNewData[1];
    setData[1] = tempNewData[2];
    setData[2] = tempNewData[3];
    setData[3] = tempNewData[0];
  } else if (analysis.indicator.id == 1293 && setData.length == 3) {
    let tempNewData = [...setData];
    setData[0] = tempNewData[1];
    setData[1] = tempNewData[2];
    setData[2] = tempNewData[0];
  }

  if (isBreakDown) {
    let mainIndicator = setData.shift();
    if (mainIndicator.values.length != 0) {
      mainIndicator.values = [
        ...mainIndicator.values,
        getUrlParams().groupby == 'minutes15' && getLastPoint(mainIndicator),
      ];
    }
    mainIndicator.type = 'line';
    const maxLengthIndicator = setData.reduce((p, c) =>
      c.values.length < p.values.length ? p : c
    ).values;
    const maxLength = maxLengthIndicator.length;
    setData = setData.filter((i) => i.values.length !== 0);
    setData = setData.map((i) => {
      let result = i;
      if (i.values.length !== maxLength) {
        const currentValues = i.values;
        result = { ...i, values: [] };
        for (let value of maxLengthIndicator) {
          const realXY = currentValues.find(
            (i) => i.x.getTime() === value.x.getTime()
          ) || {
            x: value.x,
            y: 0,
          };
          result.values.push(realXY);
        }
      }
      return result;
    });
    setData = [
      {
        type: 'area',
        stacking: true,
        data: setData.map((data, i) => ({
          areaOpacity: 1,
          stacking: true,
          type: 'area',
          mainIndicator: mainIndicator.id,
          color: getColour(i),
          ...data,
          values: [...data.values, getLastPoint(data)],
        })),
      },
    ];
    setData.push(mainIndicator);
  } else {
    setData = setData.map((data, i) => {
      let values = [...data.values];
      if (data.values.length > 0 && data.step_type == 'step') {
        values =
          getUrlParams().groupby == 'minutes15'
            ? [...data.values]
            : [...data.values, { ...getLastPoint(data) }];
      }

      return {
        id: `${data.id}`.replaceAll(' ', '_'),
        areaOpacity: 1,
        type: isBreakDown ? 'area' : 'line',
        dots: true,
        color: getColour(i),
        ...data,
        values: [...values],
      };
    });
  }

  if (tabSelected === 'composition') {
    setData = setData.map((el) => {
      if (el.value < 0) {
        return {
          ...el,
          sign: '-',
          value: el.value * -1,
        };
      } else {
        return {
          ...el,
          sign: '',
        };
      }
    });
  }
  setData = setData.map((el) => {
    return {
      ...el,
      id: `${el.id}`.replaceAll(' ', '_'),
    };
  });

  return setData;
};

export const getUnit = (id) => {
  const units = {
    13: 'MWh',
    20: 'MW',
    21: 'MW',
    22: 'MV',
    23: '€/MWh',
    24: '€',
    152: '%',
    153: ' ',
    159: ' ',
    209: 'tCO2',
    211: '€/tCO2',
    217: 'tCO2/MW',
    238: '€/ton',
  };
  return units[id] || '';
};
export const getDecimal = (magnitud) => {
  var decimals = {
    24: 2,
    23: 2,
    152: 6,
    153: 0,
    159: 0,
    211: 3,
    217: 3,
    20: 0,
    13: 1, // for graph it should be 0
    238: 2,
  };
  return decimals[magnitud];
};

export const getDecimalAnalysisSumm = (magnitud) => {
  var decimals = {
    13: 1, //LISTO
    20: 1, // LISTO
    21: 1, // LISTO
    22: 0, // Pdte.
    23: 2, // LISTO
    24: 2, // Pdte.
    152: 6, // LISTO
    153: 0, // Pdte.
    159: 0, // Pdte.
    209: 1, // LISTO
    211: 3, // LISTO
    217: 3, // LISTO
    238: 2, // LISTO
  };
  let toReturn =
    decimals[magnitud] || decimals[magnitud] == 0 ? decimals[magnitud] : 1;
  return toReturn;
};
